// utils
import { paramCase } from 'src/utils/change-case';
import { _id, _postTitles } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneUI: 'https://mui.com/store/items/zone-landing-page/',
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma:
    'https://www.figma.com/file/kAYnYYdib0aQPNKZpgJT6J/%5BPreview%5D-Minimal-Web.v5.0.0?type=design&node-id=0%3A1&t=Al4jScQq97Aly0Mn-1',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id: string) => `/product/${id}`,
    demo: {
      details: `/product/${MOCK_ID}`,
    },
  },
  post: {
    root: `/post`,
    details: (title: string) => `/post/${paramCase(title)}`,
    demo: {
      details: `/post/${paramCase(MOCK_TITLE)}`,
    },
  },
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      verify: `${ROOTS.AUTH}/jwt/verify`,
      register: `${ROOTS.AUTH}/jwt/register`,
      newPassword: `${ROOTS.AUTH}/jwt/new-password`,
      newChangePassword: `${ROOTS.AUTH}/jwt/new-changepassword`,
      forgotPassword: `${ROOTS.AUTH}/jwt/forgot-password`,
    },
  },
  authDemo: {
    classic: {
      login: `${ROOTS.AUTH_DEMO}/classic/login`,
      register: `${ROOTS.AUTH_DEMO}/classic/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/classic/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/classic/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/classic/verify`,
    },
    modern: {
      login: `${ROOTS.AUTH_DEMO}/modern/login`,
      register: `${ROOTS.AUTH_DEMO}/modern/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/modern/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/modern/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/modern/verify`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    mail: `${ROOTS.DASHBOARD}/mail`,
    chat: `${ROOTS.DASHBOARD}/chat`,
    blank: `${ROOTS.DASHBOARD}/blank`,
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,

    verification: {
      root: `${ROOTS.DASHBOARD}/verification`,
      insurance: `${ROOTS.DASHBOARD}/verification/insurance`,
      certificate: `${ROOTS.DASHBOARD}/verification/certificate`,
      moderated: `${ROOTS.DASHBOARD}/verification/moderated`,
    },

    

    
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      // adminUser: `${ROOTS.DASHBOARD}/user/adminUser`,
      editadminuser: (id: string) => `${ROOTS.DASHBOARD}/user/admindetails/edit/${id}`,
      editAdminUser: `${ROOTS.DASHBOARD}/user/editAdminUser`,
      newSparkfeed: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/newSparkfeed`,
      editcategory: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/editcategory`,
      viewRoles: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/viewRoles`,
      viewCategory: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/viewCategory`,
      addSparkfeed: `${ROOTS.DASHBOARD}/user/addSparkfeed`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
      appUser: `${ROOTS.DASHBOARD}/user/appUser`,
      facility: `${ROOTS.DASHBOARD}/user/facility`,
      professional: `${ROOTS.DASHBOARD}/user/professional`,
      viewappuserdetails: (id: string) => `${ROOTS.DASHBOARD}/user/appUser/userdetails/${id}`,
      viewprofessionalappuserdetails: (id: string) => `${ROOTS.DASHBOARD}/user/professional/userdetails/${id}`,
      viewfacilityappuserdetails: (id: string) => `${ROOTS.DASHBOARD}/user/facility/userdetails/${id}`,
      editappuserdetails: (id: string) => `${ROOTS.DASHBOARD}/user/appUser/userdetails/edit/${id}`,
      editprofessionalappuserdetails: (id: string) => `${ROOTS.DASHBOARD}/user/professional/userdetails/edit/${id}`,
      editfacilityappuserdetails: (id: string) => `${ROOTS.DASHBOARD}/user/facility/userdetails/edit/${id}`,
    },

    accessrole:{
      root: `${ROOTS.DASHBOARD}/accessrole`,
      permissions: `${ROOTS.DASHBOARD}/accessrole/permissions`,
      adminUser: `${ROOTS.DASHBOARD}/accessrole/adminUser`,
      deletePermission: `${ROOTS.DASHBOARD}/accessrole/deletePermission`,
      chatPermission: `${ROOTS.DASHBOARD}/accessrole/chatPermission`,
      bulkupload: `${ROOTS.DASHBOARD}/accessrole/bulkupload`,
      bulkImportList: `${ROOTS.DASHBOARD}/accessrole/bulkImportList`,
      addRoles: `${ROOTS.DASHBOARD}/accessrole/addRoles`,
      editRoles: (id: string) => `${ROOTS.DASHBOARD}/accessrole/${id}/editRoles`,
      viewRoles: (id: string) => `${ROOTS.DASHBOARD}/accessrole/${id}/viewRoles`,
      new: `${ROOTS.DASHBOARD}/accessrole/new`,
      viewadminuser: (id: string) => `${ROOTS.DASHBOARD}/accessrole/admindetails/${id}`,

    },
    

    finance: {
      root: `${ROOTS.DASHBOARD}/finance`,
      advertisementdetails: `${ROOTS.DASHBOARD}/finance/advertisementdetails`,
      advertisement: `${ROOTS.DASHBOARD}/advertisement`,
      addadvertisement: `${ROOTS.DASHBOARD}/finance/addadvertisement`,
      editAdvertisement: (id: string) => `${ROOTS.DASHBOARD}/finance/${id}/editAdvertisement`,
      viewAdvertisement: (id: string) => `${ROOTS.DASHBOARD}/finance/${id}/viewAdvertisement`,
      viewProduct: `${ROOTS.DASHBOARD}/finance/viewproduct`,
      addProduct: `${ROOTS.DASHBOARD}/finance/addProduct`,
      editProduct: (id: string) => `${ROOTS.DASHBOARD}/finance/editProduct/${id}`,
      details: (id: string) => `${ROOTS.DASHBOARD}/finance/details/${id}`,
      subcription: `${ROOTS.DASHBOARD}/finance/subscription`,
    },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      new: `${ROOTS.DASHBOARD}/product/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/product/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/product/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/product/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/product/${MOCK_ID}/edit`,
      },
    },
    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/invoice/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}/edit`,
      },
    },
    post: {
      root: `${ROOTS.DASHBOARD}/post`,
      new: `${ROOTS.DASHBOARD}/post/new`,
      details: (title: string) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}`,
      edit: (title: string) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}`,
        edit: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}/edit`,
      },
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      details: (id: string) => `${ROOTS.DASHBOARD}/order/${id}`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
      },
    },
    job: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/job/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/job/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/job/${MOCK_ID}/edit`,
      },
    },
    tour: {
      root: `${ROOTS.DASHBOARD}/tour`,
      new: `${ROOTS.DASHBOARD}/tour/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/tour/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/tour/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}/edit`,
      },
    },
  },
};
